<template>
  <a-card :bordered="false">
    <!-- 操作 -->
    <div class="table-operations">
      <a-button type="primary" @click="showCreateModal">
        <a-icon type="plus" />新增
      </a-button>
    </div>
    <!-- 数据展示 -->
    <a-table ref="dragTable" :loading="loading" rowKey="id" :columns="columns" :data-source="list"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
      :bordered="tableBordered" :customRow="customRow">
      <img slot="coverUrl" slot-scope="text, list" style="width: 48px;height: 48px;" :preview="list.coverUrl"
        v-image-preview :src="list.coverUrl">
      <template slot="isFixed" slot-scope="text, record, index">
        <a-switch v-if="index < 2" :checked="record.isFixed" @change="toggleFixed(record)" checked-children="固定"
          un-checked-children="取消" />
      </template>
      <span slot="operation" slot-scope="text, list">
        <a @click="handleDelete(list)">
          <a-icon type="delete" />删除
        </a>
      </span>
    </a-table>

    <a-drawer :title="modalTitle" :visible="drawerVisible" :width="'80%'" :maskClosable="false" :keyboard="false"
      @close="closeDrawer" destroyOnClose>
      <create-playlist v-if="drawerVisible" ref="createPlaylist" :playlistId="playlistId" :editData="currentEditData"
        :existingVideoIds="list.map(item => item.videoId)" />
    </a-drawer>
  </a-card>
</template>
  
<script>
import {
  editPlaylistVideo,
  delPlaylistVideo,
  selectPlaylistVideo,
} from '@/api/video/video'
import Sortable from 'sortablejs'
import CreatePlaylist from './CreatePlaylist'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'PlaylistDetails',
  props: {
    playlistId: {
      type: [Number, String],
      required: true
    }
  },
  components: {
    CreatePlaylist
  },
  mounted() {
    this.initSortable()
  },
  mixins: [tableMixin],
  data() {
    return {
      drawerVisible: false,
      modalTitle: '新增片单剧集',
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      queryParam: {
      },
      columns: [
        {
          title: '短剧id',
          dataIndex: 'videoId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '封面图',
          dataIndex: 'coverUrl',
          align: 'center',
          width: '180',
          scopedSlots: { customRender: 'coverUrl' }
        },
        {
          title: '短剧名称',
          dataIndex: 'videoName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否固定',
          dataIndex: 'isFixed',
          scopedSlots: { customRender: 'isFixed' },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created() {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    toggleFixed(record) {
      // 切换固定状态（0 → 1 或 1 → 0）
      record.isFixed = record.isFixed === 1 ? 0 : 1;

      // 显示提示
      this.$message.success(record.isFixed === 1 ? '已固定' : '已取消固定');

      // 调用接口时包装成数组
      editPlaylistVideo([record])
        .then(() => {
          this.$message.success('状态已更新');
        })
        .catch(() => {
          this.$message.error('状态保存失败');
          // 如果保存失败，可回滚状态
          record.isFixed = record.isFixed === 1 ? 0 : 1;
        });
    },

    getList() {
      this.loading = true
      selectPlaylistVideo({ playlistId: this.playlistId }).then(response => {
        this.list = response.data
        this.loading = false
      })
    },

    // 拖拽初始化
    initSortable() {
      const el = this.$refs.dragTable?.$el?.querySelector('.ant-table-tbody')
      if (!el) return

      Sortable.create(el, {
        animation: 150,
        ghostClass: 'sortable-ghost',
        onEnd: evt => {
          const movedItem = this.list.splice(evt.oldIndex, 1)[0]
          this.list.splice(evt.newIndex, 0, movedItem)

          // 更新排序字段
          const sortedData = this.list.map((item, index) => ({
            id: item.id,
            sort: index + 1,
            isFixed: 0
          }))

          // 立即提交
          editPlaylistVideo(sortedData).then(() => {
            this.$message.success('排序已更新')
            this.getList()
          }).catch(() => {
            this.$message.error('排序保存失败')
          })
        }
      })
    },

    showCreateModal() {
      this.modalTitle = '新增片单'
      this.currentEditData = null
      this.drawerVisible = true
      this.$nextTick(() => {
        this.$refs.createPlaylist.resetForm()
      })
    },
    closeDrawer() {
      this.drawerVisible = false
      this.getList()
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delPlaylistVideo(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
  }
}
</script>
  